// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__d6NS2","active":"styles_active__3I0H-","button":"styles_button__13MkP","disabled":"styles_disabled__1AdHO"};